<template>
    <div>
        <div class="btn-row">
            <Button class="btn-confirm"
                :btnId="primaryBtnId"
                :btnMsg="primaryBtnMsg"
                @clickButton="clickPrimaryBtn" />
            <Button class="btn-cancel"
                :btnId="secondaryBtnId"
                :btnMsg="secondaryBtnMsg"
                @clickButton="clickSecondaryBtn" />
        </div>
    </div>
</template>
<script>
import Button from './Button.vue';
export default {
    name: 'ValidateButton',
    components: {
        Button
    },
    props: {
        primaryBtnId: String,
        primaryBtnMsg: String,

        secondaryBtnId: String,
        secondaryBtnMsg: String,
    },
    methods: {
        //event
        clickPrimaryBtn: function () {
            this.$emit('clickPrimaryBtn');
        },
        clickSecondaryBtn: function () {
            this.$emit('clickSecondaryBtn');
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/baseDisplay.scss';
.btn-row {
    
    .btn-confirm {
        width: 90%;
        margin: auto;
    }

    .btn-cancel {
        width: 90%;
        margin: -25px auto 20px;
    }
}
</style>
